export default __webpack_public_path__ + "static/media/scanqr 1024.52c50196.svg";